import systemVerilogForAsicFpgaDesignAndSimulationImage from "../../components/ProgramCatalog/assets/system-verilog-for-asic-fpga-design-and-simulation.webp";
import entcImage from "../../components/CoursePage/assets/entc-logo.webp";
import svdsFlyer from "../../components/CoursePage/assets/SVDS-26-batch3-flyer.jpg";
import { ECourseStatus, ICourse } from "../utils/utils";

export const systemVerilogForAsicFpgaDesignAndSimulation: ICourse = {
  header: {
    courseImage: systemVerilogForAsicFpgaDesignAndSimulationImage,
    programCategory: "Short Course",
    difficultyLevel: "Beginner",
    courseTitle: "{System}Verilog for ASIC/FPGA Design & Simulation ’26 (Batch 03)",
    specialization: "Build Your Own CPU",
    courseDescription:
      "Processor design plays a significant role in determining the performance and capabilities of a computer. “{System}Verilog for ASIC/FPGA Design & Simulation” is the second course of the “Build Your Own CPU” specialization. Get comprehensive training on digital design within 16 sessions, including a completion certificate from Skill Surf!",
    registerButton: "Enroll Now",
    registerLink: "https://learnova.skillsurf.lk/course-preview/27052",
    secondaryName: "Registration closed. Registered participants enroll by 15 November 2026, 11.59 PM IST",
  },
  headerSecondSection: {
    starCount: 5,
    reviewCount: 60,
    registrationDeadline: "15th November 2026, 11.59 PM IST",
    deadlineLabel: "Enrollment Deadline:",
    parameterOne: "Duration",
    parameterTwo: "16 Sessions",
    alternativeTag: "Third Intake",
    parameterThree: "New Course",
    collaborationLogos: [
      {
        collaborationLogo: entcImage,
        collaborationLogosName: "ENTC Logo",
      },
    ],
  },
  courseOutline: [
    {
      session: "",
      sessionContent: [
        {
          heading: "Introduction  to HDLs, FPGAs, Synthesis, Verification",
          description: "",
          subContent: [],
        },
        {
          heading:
            "Learn SystemVerilog design and simulation through seven digital circuits:",
          description: "",
          subContent: [
            {
              heading: "",
              description: "1-bit full adder",
            },
            {
              heading: "",
              description: "N-bit full adder",
            },
            {
              heading: "",
              description: "Combinational ALU",
            },
            {
              heading: "",
              description: "Counter",
            },
            {
              heading: "",
              description: "Parallel to Serial Converter (State machine)",
            },
            {
              heading: "",
              description: "FIR Filter",
            },
            {
              heading: "",
              description: "Matrix-Vector Multiplier",
            },
          ],
        },
        {
          heading: "Best practices, gotchas & more",
          description: "",
          subContent: [],
        },
        {
          heading: "OSIC Tools, OpenLane, and TinyTapeout",
          description: "",
          subContent: [],
        },
      ],
    },
  ],
  faqs: [
    {
      question: "Who can participate?",
      answer:
        "This course is highly recommended for those who have already taken the “Fundamentals of Digital System Design” course offered by Skill Surf. Those who have not, but are interested in taking this course, will be given access to the course material separately.",
    },
    {
      question: "How much is the course fee?",
      answer:
        "25,000 LKR for Sri Lankan residents and 190 USD for non-Sri Lankan residents. Current Sri Lankan undergraduates get a 40% discount.",
    },
    {
      question: "Is registration still open?",
      answer:
        "Registration closed on 31st October 2026. The enrollment period is now open, and registered participants must complete their enrollment by 11.59 PM IST on 15th November 2026 using the “Enroll Now” button.",
    },
    {
      question: "Why should I take this course?",
      answer:
        "Build real-world digital designs with SystemVerilog through hands-on projects, gain practical ASIC/FPGA skills using industry-relevant tools like OpenLane and Tiny Tapeout, strengthen your path toward processor design as part of the Build Your Own CPU specialization, learn industry best practices for efficient and reliable digital design, and earn a Skill Surf certificate to showcase your newly developed skills.",
    },
    {
      question:
        "I have no prior knowledge of SystemVerilog or processor design. Will I be able to do this course?",
      answer:
        "The course does not require any prior experience in processor design. As long as you have a background in basic computer programming, we will provide you with the necessary ingredients to get started in this domain and become an expert.",
    },
    {
      question:
        "Do I need electronic equipment/software licenses to complete this course?",
      answer:
        "No hardware is required for the course. You will get access to the OSIC (open-source IC design) tools required for the course free of charge, and learn how to do actual digital designs on hardware with Tiny Tapeout.",
    },
    {
      question:
        "Will I be able to build things at the end of the course, or is it only theory?",
      answer:
        "Of course, you will be able to build things. The course is outcome-oriented, so at the end of the course, you will know how to develop cool processor components from scratch.",
    },
    {
      question: "Is the course taught online?",
      answer:
        "Yes. The course is conducted via Zoom in English medium. Sinhala and Tamil explanations are given based on participant requests.",
    },
    {
      question: "Will lecture recordings be made available?",
      answer:
        "Yes. All course materials will be made available through an online learning management system called Moodle. All paid participants will be granted access to the course Moodle page.",
    },
    {
      question: "Who do I contact for more details?",
      answer:
        "Email us at skillsurfedu@gmail.com.",
    },
  ],
  experts: [],
  studentReviews: [
    "On the 1st day, when I saw the registration details, I went through the course curriculum and I joined the course with an expectation. The team fulfilled my expectations 100%.",
    "The course is very interesting and provides a good knowledge in the intended learning area. I would like to see more courses like this in future.",
    "This was a great course. Although the instructors couldn't touch all the aspects, guiding the students on what to follow and refer to is a great thing. Grateful for the organizers and instructors sharing their knowledge. Hope to join the next courses as well.",
    "The personal ML/embedded projects that the instructors shared as case studies were really inspiring. Sharing the ups and downs and what to expect along this path is a real motivator!",
    "Flow of the content was really great. It will really help to beginners who are entering to ML & Edge computing.",
  ],
  facts: [
    {
      fact: "SystemVerilog is not an entirely new RTL language. With its rich set of extensions to the existing Verilog HDL, SystemVerilog is backward compatible with both Verilog 95 and Verilog 2001. Many of these extensions to Verilog make it easier to create accurate, synthesizable models of designs of any size",
      factBold: "",
      author: "-EETimes-",
    },
    {
      fact: "The global Application Processor Market is expected to reach USD 38 billion by 2024, at a CAGR of 5.5% from 2018 to 2024.",
      factBold: "",
      author: "-MarketWatch-",
    },
  ],
  classSchedule: [
    "Starts 7th November 2026 (16 sessions)",
    "Saturdays & Sundays, 08.30 PM – 09.30 PM",
    "Conducted via Zoom in English medium",
    "Registration closed on 31st October 2026",
    "Enrollment open until 15th November 2026, 11.59 PM IST (registered participants)",
  ],
  showSchedule: true,
  prerequisite:
    "Highly recommended for those who have already taken the “Fundamentals of Digital System Design” course offered by Skill Surf. Those who have not will be given access to the course material separately.",
  isCourseFlyer: true,
  flyer: {
    description:
      "Learn more about the {System}Verilog for ASIC/FPGA Design & Simulation ’26 (Batch 03) course from the course flyer",
    button: "View Course Flyer",
    image: svdsFlyer,
  },
  courseStatus: ECourseStatus.NEW,
  youtubeVideoUrl: "https://www.youtube-nocookie.com/embed/ClScIlHIBbk",
  showTimer: true,
  timerDate: "2026-11-15T23:59:59+05:30",
  isCourseFee: true,
  courseFeeAmount: "LKR 25,000 / USD 190",
  discountAmount: "40% off for current Sri Lankan undergraduates",
  learnMore: {
    description:
      "Learn more about SystemVerilog design & simulation and the custom processor design market in general",
    button: "Read More",
    articleLink:
      "https://medium.com/@SkillSurfLK/embedded-machine-learning-for-edge-computing-4598eb8df1b1",
  },

  /* firstSessionFreeDetails: {
    instruction: {
      isInstructive: false,
      instructiveText:
        "The first session, which was free of charge to everyone, was held on 11 January 2025. The recording of the session is made available below.",
      instructiveTextSecond:
        "Only paid participants can attend from day 2 onwards. So, please complete the payment by",
      date: "",
      dateSecond: "23 January 2025.",
      buttonText: "View Course Outline",
      buttonTextInfo: "View Slides",
      viewIntruction: "",
      instructionVideoTopic:
        "Recording of the first sessions held on 11 January 2025",
      instructionVideoUrl: "oy3kuFWbtgg",
      videoTwoTopic: "",
      videoTwoUrl: "",
      viewIntructionLink: "",
      buttonLink: "",
      buttonLinkInfo:
        "",
      moreInformation:
        "For any questions, please email skillsurfedu@gmail.com.",
      slideButtonText: "Download Slides:",
      paymentInstructionButtonText: "here",
      paymentInstructionButtonLink:
        "https://drive.google.com/file/d/1SKkpGmoYZwXH7SDMyDu1VPr6PPgerjLa/view?usp=sharing",
      paymentInstructionText:
        "Payment and other related instructions can be found",
      enrollmentFormLink: "https://forms.gle/XjZm2F35TYajh6We9",
      
    },
  }, */
  meetSection: {
    meetDetails: false,
    introPara:
      "The introductory session, which is free of charge to everyone, will be held on 11th January (Saturday) 2025 at 7.00 pm IST. This first session will give an overview of the course, the content covered, and the expected outcomes. Please use the Zoom link to join the session:",
    zoomLink:
      "https://learn.zoom.us/j/66480277252?pwd=STVxa2hlRi9SS0hGOU1RZlY0OTRwUT09",
    meetId: "664 8027 7252",
    passCode: "R?4xedWg",
    zoomLinkText: "Click here to join ",
    introSecondPara:
      "The introductory session and an email following the session will provide further instructions on how to make the payments and enroll in the course. See you on 11th!",
  },
};
